import checkmarkIcon from 'presentation/assets/icons/png/3x/circle-check-info@3x.png';

import CenteredLoadingIndicator from 'presentation/components/CenteredLoadingIndicator';
import Icon, { ICONSIZE } from 'presentation/components/Icon';
import { parse } from 'query-string';
import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { paths } from 'frameworks_drivers/routes';
import { AcquisitionClient } from '../../../clients';

interface Props {}

interface State {
  APICallInProgress: boolean;
  type?: string;
  id?: string;
  key?: string;
}

const ConfirmEMailViaLinkPage: React.FC<Props> = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [state, setState] = useState<State>({ APICallInProgress: true });

  useEffect(() => {
    var urlParameters = parse(location.search);

    // TODO: Change to modal
    if (!urlParameters.type) {
      alert(
        t('confirmEMailViaLinkAlertPasteWarningText', {
          error: 'Kein mail confirmation type'
        })
      );
    } else if (!urlParameters.id) {
      alert(
        t('confirmEMailViaLinkAlertPasteWarningText', {
          error: 'Keine mail confirmation id'
        })
      );
    } else if (!urlParameters.key) {
      alert(
        t('confirmEMailViaLinkAlertPasteWarningText', {
          error: 'Kein mail confirmation key'
        })
      );
    } else {
      const { type, id, key, rkey } = urlParameters as {
        type: string;
        id: string;
        key: string;
        rkey?: string;
      };

      const apiClient = new AcquisitionClient();
      apiClient
        .confirmEmailById(id, type, key)
        .then((confirmMailResponse) => {
          setState({
            APICallInProgress: false
          });

          setTimeout(() => {
            navigate(
              {
                pathname: paths.EMailConfirmed,
                search: `type=${type}&id=${id}${!!rkey ? `&rkey=${rkey!}` : ''}`
              },
              { replace: true }
            );
          }, 1000);
        })
        .catch((error: any) => {
          if (error.response.status === 401) {
            alert(
              t('confirmEMailViaLinkResponseErrorAlertText', {
                error: '401 invalid offer id'
              })
            );
          } else if (error.response.status === 404) {
            alert(
              t('confirmEMailViaLinkResponseErrorAlertText', {
                error: '404 Invalid key'
              })
            );
          }
          console.error('Error confirming e-mail address!');
          console.error(error);
        });
    }
  }, [location.search, t, navigate]);

  return (
    <div className="d-flex flex-column w-100 h-100 position-absolute top-0 start-0 bg-transparent">
      {state.APICallInProgress ? (
        <div className="m-auto" style={{ transitionDuration: '350ms' }}>
          <Row>
            <Col xs={12} className="d-flex" style={{ margin: '30px 0' }}>
              <span className="m-auto">{t('confirmEMailViaLinkProcessText')}</span>
            </Col>
            <Col xs={12} style={{ minHeight: '300px' }}>
              <CenteredLoadingIndicator />
            </Col>
          </Row>
        </div>
      ) : (
        <div className="m-auto" style={{ transitionDuration: '350ms' }}>
          <Row>
            <Col xs={12} className="d-flex" style={{ margin: '30px 0' }}>
              <span className="m-auto">{t('confirmEMailViaLinkSuccessText')}</span>
            </Col>
            <Col xs={12}>
              <Icon iconSrc={checkmarkIcon} size={ICONSIZE.xxlarge} alt="checkmark icon"></Icon>
            </Col>
          </Row>
        </div>
      )}
    </div>
  );
};

export default ConfirmEMailViaLinkPage;
